// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__OO2-Q","tab":"Tabs_tab__ASEEQ","tabActive":"Tabs_tabActive__3hfzE"};